
<div class="embeded-player" id="{{playerName + medium!.id + medium!.provider}}" ></div>

